
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDrawableItemEditable } from "../IDrawableItemEditable";
import { IDrawableItem } from "../../../../domain/document/items";

@Component({
})
export default class DrawableObjectEditorMixin extends Mixins() {
  @Prop()
  source: IDrawableItemEditable;

  @Prop()
  shownDisabledDescription: string;

  get editingSource(): IDrawableItem {
    return this.source.editingSource;
  }

  get isEditable(): boolean {
    return this.editingSource.isEditable;
  }
}
